<template>
  <div :class="{
    'custom-file': true,
    'invalid': isInvalid
  }">
    <input
      ref="input"
      type="file"
      @change="index !== false ? onChange($event, index) : onChange($event)"
      class="custom-file-input"
      :id="id"
      :aria-describedby="id"
      :multiple="multiple"
      :disabled="disabled" />
    <label
      class="custom-file-label"
      :for="id">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'file-input',
  props: {
    id: {
      default: '',
      type: String,
      required: true
    },
    index: {
      default: false,
      type: [Boolean, Number],
      required: false
    },
    label: {
      default() {
        return this.$t('ui.selectFile');
      },
      type: String
    },
    isInvalid: {
      default: false,
      required: false,
      type: Boolean
    },
    multiple: {
      default: false,
      type: Boolean,
      required: false
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false
    },
    onChange: {
      default: () => false,
      required: false,
      type: Function
    }
  },
  mounted () {
    this.$refs['input'].addEventListener('change', this.updateLabel);
  },
  methods: {
    updateLabel (e) {
      if (this.multiple) {
        let files = document.getElementById(this.id).files;
        let nextSibling = e.target.nextElementSibling;
        let fileNames = [];

        for (let i = 0; i < files.length; i++) {
          fileNames.push(document.getElementById(this.id).files[i].name);
        }

        nextSibling.innerText = fileNames.join(', ');
      } else {
        let fileName = document.getElementById(this.id).files[0].name;
        let nextSibling = e.target.nextElementSibling;
        nextSibling.innerText = fileName;
      }
    }
  },
  beforeDestroy () {
    this.$refs['input'].removeEventListener('change', this.updateLabel);
  }
}
</script>

<style lang="scss">
.custom-file.invalid {
  position: relative;

  &:before {
    background: red;
    border-radius: 5px;
    content: "";
    height: calc(100% + 2px);
    left: -1px;
    position: absolute;
    top: -1px;
    width: calc(100% + 2px);
  }
}
</style>
